/* RESPONSIBLE TEAM: team-inbox-experience */

export function assertExists<T>(value: T): asserts value is NonNullable<T> {
  if (value === undefined || value === null) {
    throw new Error(`expected ${value} to exist`);
  }
}
